import {
  contentProofPickerContextSchema,
  contentProofPickerHydrationResponseSchema,
  contentProofPickerListResponseSchema,
  proofPickerConsumerReferenceSchema,
  reviewDueProofPickerContextSchema,
  reviewDueProofPickerHydrationResponseSchema,
  reviewDueProofPickerListResponseSchema,
  type ReviewDueProofPickerHydrationResponse,
  type ContentProofPickerHydrationResponse,
} from '@/lib/proof-system/picker-contracts';
import { proofApiFetch } from './proof-api-client';

export const proofPickerService = {
  async listContent(input: unknown) {
    const context = contentProofPickerContextSchema.parse(input);
    const params = new URLSearchParams({
      view: 'content_picker',
      channel: context.channel,
      targetState: context.targetState,
      jurisdictionTag: context.jurisdictionTag,
    });
    const payload = await proofApiFetch(
      `/api/proof-metrics?${params.toString()}`,
      contentProofPickerListResponseSchema,
    );
    return payload.items;
  },

  async hydrateContent(consumerId: string): Promise<ContentProofPickerHydrationResponse> {
    const consumer = proofPickerConsumerReferenceSchema.parse({
      consumerType: 'content',
      consumerId,
    });
    const params = new URLSearchParams({
      view: 'content_picker_hydration',
      consumerId: consumer.consumerId,
    });
    return proofApiFetch(
      `/api/proof-metrics?${params.toString()}`,
      contentProofPickerHydrationResponseSchema,
    );
  },

  async listReviewDue(input: unknown) {
    const context = reviewDueProofPickerContextSchema.parse(input);
    const params = new URLSearchParams({
      view: 'review_due_picker',
      reviewType: context.reviewType,
      locationId: context.locationId,
    });
    const payload = await proofApiFetch(
      `/api/proof-metrics?${params.toString()}`,
      reviewDueProofPickerListResponseSchema,
    );
    return payload.items;
  },

  async hydrateReviewDue(consumerId: string): Promise<ReviewDueProofPickerHydrationResponse> {
    const consumer = proofPickerConsumerReferenceSchema.parse({
      consumerType: 'review_due',
      consumerId,
    });
    const params = new URLSearchParams({
      view: 'review_due_picker_hydration',
      consumerId: consumer.consumerId,
    });
    return proofApiFetch(
      `/api/proof-metrics?${params.toString()}`,
      reviewDueProofPickerHydrationResponseSchema,
    );
  },
};
